import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { Metric } from "@/entities/Finance/Finance.model";
import { AIMViewType } from "../../InvestmentMemo.types";
import { AIMContextViewAtom } from "../../state/context.state";

export function useMetricClickHandler() {
    const setAIMContextView = useSetAtom(AIMContextViewAtom);
    return useCallback(
        (metric: Metric | undefined, title: string) => {
            setAIMContextView({
                type: AIMViewType.LABS_LINEAGE,
                metric,
                title,
            });
        },
        [setAIMContextView],
    );
}
